import Big from "big.js";

const ONE = Big(1);
const DAYS_PER_YEAR = Big(360);

const startPriceCalculator = {
	calculateWithDiscount: calculateWithDiscount,
	calculateDiscountPercentageWithInterestRate: calculateDiscountPercentageWithInterestRate
}

/**
 * @param data Matches the data returned from the backend for an approved receivable
 * @param discountPercentage The desired discount rate as configured, e.g. 2, for 2%
 * @returns The calculated price
 */
function calculateWithDiscount(data, discountPercentage) {
	let discountRate = Big(discountPercentage / 100)
	let receivableAmount = Big(data.amount);
	let price = receivableAmount.times(ONE.minus(discountRate));

	return Number(price.round(2));
}

/**
 * @param data Matches the data returned from the backend for an approved receivable
 * @param interestPercentage The desired annual interest rate as configured, e.g. 5 for 5%
 * @returns The calculated discount
 */
function calculateDiscountPercentageWithInterestRate(data, interestPercentage, params) {
	let interestRate = Big(interestPercentage / 100);
	let dueDate = moment(moment(data.dueDate).format("YYYY-MM-DD"));
	let invoiceDate = moment(moment(data.invoiceDate).format("YYYY-MM-DD"));
	let paymentTerm = Big(dueDate.diff(invoiceDate, 'days'));

	return Number((interestRate.times(paymentTerm).div(DAYS_PER_YEAR)).div(ONE.plus((interestRate.times(paymentTerm).div(DAYS_PER_YEAR)))).times(100));
}

export {
	startPriceCalculator
};